(function (){
    const ready = require('./libs/ready');
    const wait30frames = require('./libs/wait30frames');

    function main(){
        wait30frames.add(() => {
            require('./PowerSupply/power-supply');
            require('./Product/AI_side_ad');
            require('./Product/Fix_Laptop2024_section_rgb');
        });
    }
    ready(main);
})();